/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cmp_Hero_Cta_Secondary_AgentsInputs */

const en_cmp_hero_cta_secondary_agents = /** @type {(inputs: Cmp_Hero_Cta_Secondary_AgentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`See the Bystep agent team`)
};

const id_cmp_hero_cta_secondary_agents = /** @type {(inputs: Cmp_Hero_Cta_Secondary_AgentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lihat tim agent Bystep`)
};

/**
* | output |
* | --- |
* | "See the Bystep agent team" |
*
* @param {Cmp_Hero_Cta_Secondary_AgentsInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cmp_hero_cta_secondary_agents = /** @type {((inputs?: Cmp_Hero_Cta_Secondary_AgentsInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cmp_Hero_Cta_Secondary_AgentsInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cmp_hero_cta_secondary_agents(inputs)
	return en_cmp_hero_cta_secondary_agents(inputs)
});